import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { LotteryResultService } from 'baseline-lib';


/**
 * Generated class for the ResultDetailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-result-detail',
  templateUrl: 'result-detail.html',
})
export class ResultDetailPage {
  
  constructor(public navCtrl: NavController, public navParams: NavParams,public _lotteryResultService: LotteryResultService,) {

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ResultDetailPage');
   
  }

}



// WEBPACK FOOTER //
// ./src/app/result/result-detail/result-detail.ts